import { render, staticRenderFns } from "./motionGraphics.vue?vue&type=template&id=34b397c0&"
import script from "./motionGraphics.vue?vue&type=script&lang=js&"
export * from "./motionGraphics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports